<template>
  <div class="exhibition">
    <div class="exhibition-title">游戏截图</div>
    <div class="exhibition-vessel" >
      <div class="exhibition-items" :style="{width:185*exhibitionList.length+'px'}">
        <div class="exhibition-item" style="width: 180px" v-for="(item,index) in exhibitionList" :key="index">
          <img :src="item.src">
        </div>
      </div>
    </div>
    <div class="label-type" v-if="typeList">
      <span class="label" v-for="(item,index) in typeList" :key="index">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Exhibition',
  props: {
    exhibitionTitle: {
      type: String,
      default: '游戏截图'
    },
    exhibitionList: {
      type: Array
      // default: ''
    },
    typeList: {
      type: Array
    }
  }

}
</script>

<style scoped lang="scss">
.exhibition{
  .exhibition-title{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F5F5F5;
    padding-bottom: 14px;
  }
  .exhibition-vessel{
    height: auto;
    overflow: auto;
    overflow-y: hidden;
    .exhibition-items{
      display: flex;
      height: auto;
      width: 1300px;
      .exhibition-item{
        width: 237px;
        margin-right: 13px;
        //background: rgba(255, 255, 255, 0.5);
        border-radius: 6px;
        >img{
          width: 100%;
        }
      }

    }
  }
  .label-type{
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    .label{
      background: rgba(21, 25, 34, 0);
      border: 1px solid #364557;
      border-radius: 20px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #F5F5F5;
      padding: 6px 10px;
      margin-right: 16px;
      margin-bottom: 10px;
    }
  }

}
</style>
